export const messages = {
  home_page_search_box: "Search for tools, datasets...",
  facets_clear_filters: "Clear filters",
  facets_save: "Save",
  facets_filter_type: "Type",
  facets_filter_keyword: "Keyword",
  facets_filter_language: "Language",
  facets_filter_mediaType: "Media type",
  facets_filter_lrType: "Asset type",
  facets_filter_open: "Free of charge",
  facets_filter_modelFunction: "Model function",
  facets_filter_public: "Public",
  facets_filter_external: "External",
  facets_filter_isUsagePolicy: "Usage policy",
  catalogue_view_policy_button: "Contract policy",
  policyDialogTitle: "Contract policy",
  facets_main_button: "Filters",
  facets_select_button: "Select filters",
  facets_show_more: "Show more",
  facets_show_less: "Show less",
  others_offers_title: "LDS Offers",
  others_offers_subtitle:
    "Explore the offers that are available in the LDS and get access to them by joining LDS",
  policy_show_more_odrl: "View the complete policy in ODRL",
  elastic_no_results_message:
    "We couldn't find any offers matching your search criteria",
  elastic_no_offers_message: "No data available for the selected connector",
  landing_page_section_categories: "Categories",
  landing_page_section_provenance: "Provenance",
  landing_page_section_documentation: "Documentation",
  landing_page_section_categories_optional: "Classification",
  landing_page_section_otherLanguages: "Detailed language",
  landing_page_section_privacy: "Data protection",
  landing_page_show_privacy: "Data Protection Information",
  all_pages_created_column: "Created",
  all_pages_price_label: "Price (excl. VAT)",
  participantListLongText:
    "The European Language Data Space (LDS) is designed as an ecosystem of organisations. Users who own language data and/or want to use language data can perform all actions related to their assets and interact with other stakeholders within the platform in a secure way and in full compliance with EU laws and regulations.",
  menu_item_offers_label: "Offers",
  offersHelpText:
    "This catalogue contains some of the datasets available in the European Language Data Space (LDS). If you join the LDS, you can get full access to the language data and models and you can also share your data assets.",
  participantsHelpText:
    "This catalogue shows some of the organisations participating in the European Language Data Space (LDS). You can share your language data and models, or discover and consume offers from other organisations by joining LDS.",
  menu_item_participants_label: "Participants",
  main_header_title: "Language Data Space Catalogue",
  name_asc: "By name asc",
  name_desc: "By name desc",
  date_asc: "By date asc",
  date_desc: "By date desc",
  filter_sort_label: "Sort by",
  policy_chip_label_publication: "Publication policy",
  policy_chip_label_usage: "Contract policy",
  all_pages_free_of_charge: "Free of charge",
  all_pages_not_free_of_charge: "Not free of charge",
  joinText: "Share and use language data and models, build language-centric AI",
  joinButton: "Join LDS",
  accessOffer: "Access offer",
  accessOfferTootip:
    "Please join LDS or, if you are already a member, go to your connector to access the offers",
  view_offer_button: "View offer",
  snippetLanguagesLabel: "Languages:",
  snippetKeywordsLabel: "Keywords:",
  footerLearnMoreLinkTitle: "About us",
  footerLearnMoreLinkText: "Learn more about the European Language Data Space",
  footerContactLinkTitle: "Contact us",
  footerContactLinkText: "Contact the European Language Data Space",
  privacyPolicyLinkText: "Privacy statement",
  LegalNoticeLinkText: "LDS General Terms and Conditions",
  matomoAcceptButtonText: "Accept",
  matomoDeclineButtonText: "Decline",
  matomoHelpText: "This site uses cookies. Visit our {cookiePolicyBannerLinkText} or click the link in the footer for more information and to change your preferences.",
  cookiePolicyBannerLinkText: "cookies policy page",
  matomoWithdrawConcentTooltip: "Withdraw coookies consent",
  cookiePolicyLinkText: "Cookie policy",
  withdrawPopUpMessage: "Are you sure you want to withdraw your consent? This will remove analytics cookies and stop further tracking.",
  withdrawYes: "Yes, withdraw",
  withdrawNo: "Cancel",
};
